export default "__VITE_ASSET__CLmWgMYo__"